module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/graph_2-4fb383ef.svg";